/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { ThreeDots } from 'react-loader-spinner';
import ReactModal from 'react-modal';
import TransferOrder from '../AssignASE/TransferOrder';

export default function ApproveRejectBlock({
    setcomment, setApproveStatus, ApproveStatus, handleApprove, handleCancel, OrderDetails, setOrderDetails, distributorDetails, comment, updated, setUpdated, validationSuccess, threeDotsLoader,
}) {
    const [transfer, setTransfer] = useState(false);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [addPopup, setaddPopup] = useState(false);
    const [transferUser, setTransferUser] = useState([]);
    const [error, setError] = useState({});
    const user = JSON.parse(localStorage.getItem('user'));
    const hasTransferOrder = user?.profile?.access_privilages?.includes('orders:transfer');
    const handleSubmit = (type) => {
        setError();
        setsubmitSelected(true);
        let errorFlag = false;
        if (comment.trim().length === 0) {
            errorFlag = true;
            setError((prev) => ({
                ...prev,
                comment: 'Please enter comment',
            }));
        }
        if (ApproveStatus === '3' && transferUser.length === 0) {
            errorFlag = true;
            setError((prev) => ({
                ...prev,
                transfer: 'Please select user',
            }));
        }
        if (errorFlag) {
            return;
        }

        if (ApproveStatus === '1') {
            handleApprove('', 'Approval');
        } else if (ApproveStatus === '0') {
            handleApprove('', 'Approval');
        } else if (ApproveStatus === '2') {
            handleCancel();
        } else if (ApproveStatus === '3') {
            handleApprove(transferUser, 'transfer');
        }
        setsubmitSelected(false);
    };
    console.log(OrderDetails, 'order-details');
    console.log(distributorDetails, 'distri-details');
    console.log(transferUser, 'transfer user');
    return (
        <>
            <div className="border-2 border-[#E29300] rounded-md bg-[#FFF5E2] h-auto p-3 my-4">
                <p className="font-semibold text-base text-[#090406]">Approval</p>
                <div className="flex -mx-0.5 pt-2.5">
                    <div className="w-1/2 px-0.5">
                        <div className="relative border border-[#800005] rounded-lg px-2 py-2 cursor-pointer flex">
                            <input
                                type="radio"
                                id="radio3"
                                name="radio-group1"
                                onChange={() => setApproveStatus('0')}
                                className="cursor-pointer"
                                checked={ApproveStatus === '0'}
                            />
                            <label htmlFor="radio3" className="flex w-full">
                                <span className="text-sm pl-8 text-[#6E1417] font-semibold relative cursor-pointer w-full">
                                    Reject
                                </span>
                            </label>
                        </div>
                    </div>
                    <div className="w-1/2 px-0.5">
                        <div className="relative checkbox border border-[#206C00] rounded-lg px-2 py-2 cursor-pointer flex">
                            <input
                                onChange={() => (validationSuccess === false ? setApproveStatus('1') : null)}
                                type="radio"
                                id="radio4"
                                name="radio-group1"
                                className="cursor-pointer"
                                checked={ApproveStatus === '1'}
                            />
                            <label htmlFor="radio4" className="flex w-full">
                                <span className="text-sm pl-8 text-[#206C00] font-semibold relative cursor-pointer w-full">
                                    Approve
                                </span>
                            </label>
                        </div>
                    </div>

                </div>
                <div className="flex">
                    <div className="w-1/2 px-0.5 mt-2">
                        <div className="relative checkbox border border-[#FFA500] rounded-lg px-2 py-2 cursor-pointer flex">
                            <input
                                onChange={() => setApproveStatus('2')}
                                type="radio"
                                id="radio5"
                                name="radio-group1"
                                className="cursor-pointer"
                                checked={ApproveStatus === '2'}
                            />
                            <label htmlFor="radio5" className="flex w-full">
                                <span className="text-sm pl-8 text-[#FFA500] font-semibold relative cursor-pointer w-full">
                                    Cancel
                                </span>
                            </label>
                        </div>
                    </div>
                    {hasTransferOrder && (
                        <div className="w-1/2 px-0.5 mt-2">
                            <div className="relative checkbox border border-[#007BFF] rounded-lg px-2 py-2 cursor-pointer flex">
                                <input
                                    onChange={() => setApproveStatus('3')}
                                    type="radio"
                                    id="radio6"
                                    name="radio-group1"
                                    className="cursor-pointer"
                                    checked={ApproveStatus === '3'}
                                />
                                <label htmlFor="radio6" className="flex w-full">
                                    <span className="text-sm pl-8 text-[#007BFF] font-semibold relative cursor-pointer w-full">
                                        Transfer
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}
                </div>

                {ApproveStatus === '3' && (
                    <div className="dropdown relative mt-3">
                        <button
                            type="button"
                            onClick={() => {
                                setaddPopup(true);
                            }}
                            // ref={ref}
                            id="role"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className={`h-12 text-left w-full rounded-lg outline-0 border bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && error?.transfer ? 'ED1C24' : 'B1B4B7'}]`}
                        >
                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Transfer To*
                            </span>
                            {transferUser.length > 0 && (
                                <p>
                                    {transferUser[0]?.FIRST_NAME}
                                    {' '}
                                    {transferUser[0]?.LAST_NAME || ''}
                                </p>
                            )}
                            <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5 selected selected-dropdown cursor-pointer" />
                        </button>
                        {submitSelected && error?.transfer !== '' && <span className="text-s font-light text-[#ED1C24]">{error?.transfer}</span>}
                    </div>
                )}
                {/* {submitSelected && errorState.role !== '' && <span className="text-s font-light text-[#ED1C24]">Role is required</span>} */}

                <div className="relative">
                    <textarea onChange={(e) => { setsubmitSelected(false); setcomment(e.target.value); }} name="" id="" className="resize-none w-full mt-2.5 border border-[#CBCBCB] rounded-md px-2.5 py-3.5 h-[85px] custom-scrollbar outline-0 text-sm font-normal text-[#555259] placeholder:text-xs13 placeholder:font-normal placeholder:text-[#A1A1A1]" placeholder={`Enter additional notes ${!['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) ? '(optional)' : ''}`} />
                    <p className="text-[7px] font-normal text-[#555259] bg-[#FFFFFF] px-1 absolute bottom-3.5 right-2.5">Max. 200 char.</p>
                </div>
                {submitSelected && error?.comment !== '' && comment.trim().length === 0 && <span className="text-s font-light text-[#ED1C24] mb-4">{error?.comment}</span>}
                <button
                    disabled={ApproveStatus === '' || threeDotsLoader}
                    onClick={() => { setUpdated(true); handleSubmit('Approval'); }}
                    type="button"
                    className="rounded-lg bg-[#555259] w-full flex justify-center items-center text-sm font-semibold text-[#ffffff] h-9"
                >
                    {threeDotsLoader ? (
                        <ThreeDots width={50} height={30} color="white" />
                    )
                        : 'Submit'}
                </button>
            </div>
            <ReactModal isOpen={addPopup} center>
                <TransferOrder
                    OrderDetails={OrderDetails}
                    setOrderDetails={setOrderDetails}
                    distributorDetails={distributorDetails}
                    setaddPopup={setaddPopup}
                    setTransferUser={setTransferUser}
                    transferUser={transferUser}
                    setError={setError}
                    transferOrder
                />
            </ReactModal>
        </>
    );
}
